import React, { useState, useEffect } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import API_URL from "../config";
import "../styles/Formularios.css";
import InputSelectIp from "./InputSelectIp";
import InputSelectGenerico from "./InputSelectGenerico";
import { useApiFetch } from "../utils/apiFetch";

function AsignarConfig() {

    const { setModuloActual, setSubModuloActual, logout } = useGlobal();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [idIp, setIdIp] = useState("");
    const [idConfi, setIdConfi] = useState("");
    const apiFetch = useApiFetch();
    const [verBoton, setVerBoton] = useState(false);

    const handleAsignarConfi = async (e) => {

        setVerBoton(false);

        if (!idConfi) {
            setError("\u274C Seleccione una configuración de la lista")
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        if (!idIp) {
            setError("\u274C Ingrese una ip válida")
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        try {

            const payload = {
                id_confi: idConfi,
                id_ip: idIp
            }

            const data = await apiFetch("asignar_configuracion.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Configuración asignada correctamente");
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setError(`\u274c ${data.message || "Error al asignar la configuración"}`);
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 3000);
            }
        } catch (err) {
            setTimeout(() => setError("\u274C Error de conexión con el servidor"), 3000);
        }
    };

    useEffect(() => {
        if (idIp && idConfi) {
            setVerBoton(true);
        } else {
            setVerBoton(false);
        }

    }, [idIp, idConfi]);

    return (
        <div className="sesion-form">
            <>
                {error && <div className="error">{error}</div>}
                {success && <div className="success">{success}</div>}
            </>

            <form>

                <InputSelectGenerico
                    idSeleccionado={idConfi}
                    setIdSeleccionado={setIdConfi}
                    label="Configuración"
                    apiUrl={`consultar_configuraciones.php`}
                    valueField="id_confi"
                    displayField="confi"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione una configuración"
                />

                <InputSelectIp
                    idIp={idIp}
                    setIdIp={setIdIp}
                    estadoFiltro=""
                    label="Seleccione una ip"
                />

                {verBoton && (
                    <div className="form-buttons">
                        <button type="button" onClick={handleAsignarConfi}>
                            Asignar Configuración
                        </button>
                    </div>
                )}

            </form>
        </div>
    );
}

export default AsignarConfig;